
    <div class="header-info">
        <button class="btn-volver" mat-raised-button (click)="volver()" >Volver</button>
        <button class="btn-finalizar" type="button" mat-raised-button (click)="guardarAvances()" *ngIf="!jardinPeriodoInforme.envioApeliacion" > Guardar Avances </button>
        <button class="btn-finalizar" type="button" mat-raised-button [disabled]="elentosApelados === 0" (click)="finalizar()" *ngIf="!jardinPeriodoInforme.envioApeliacion" > Finalizar y Enviar </button>
    </div>
    
    <div>
        <div class="card-header header-background">
            <div class="row">
                <div class="col-sm-6" style="text-align: left;">
                    <h2>Apelación</h2>
                    <p style="text-align: left;" *ngIf="!jardinPeriodoInforme.envioApeliacion" > PLAZO PARA APELAR HASTA: {{jardinPeriodoInforme.fechaLimiteApelacion | date: 'dd-MM-yyyy' }}</p>
                </div>
               
                <div class="col-sm-6" style="text-align: right;">
                   <p style="font: normal normal bold 15px/22px Montserrat;
                   letter-spacing: 0px;
                   color: #FFFFFF;
                   opacity: 1;
                   display: inline-block;"> ELEMENTOS APELADOS: {{elentosApelados}} </p>
                </div>
            </div>
        </div>
    </div>
    <div class="projects">
        <div class="card-junji">
            <mat-tab-group animationDuration="0ms" class="tabs-autoevaluacion informe-cualitativo mt-2" (selectedTabChange)="tabChanged($event)">
                <mat-tab *ngFor="let area of autoEvaluacion; let a = index">
                    <ng-template mat-tab-label>
                        <div class="num-tab">
                            <label>{{area.nombre}}</label>
                           
                        </div>
                        <div class="texto-tab">{{area.area | slice:3}}</div>
                    </ng-template>
                    <p *ngIf="numTabSelected === 0" class="tabsSection area1">12 Elementos de Gestión</p>
                    <p *ngIf="numTabSelected === 1" class="tabsSection area2">22 Elementos de Gestión</p>
                    <p *ngIf="numTabSelected === 2" class="tabsSection area3">8 Elementos de Gestión</p>
                    <p *ngIf="numTabSelected === 3" class="tabsSection area4">16 Elementos de Gestión</p>
                    <p *ngIf="numTabSelected === 4" class="tabsSection area5">8 Elementos de Gestión</p>
                    <div class="contenedor-acordeon">
                        <mat-accordion class="acordeon" *ngFor="let dimension of area.dimensiones; let d = index">
                            <mat-expansion-panel hideToggle="true" #acordeonDimension>
                                <mat-expansion-panel-header>
                                    <mat-panel-title>
                                        <span [ngClass]=" 
                                            {'estado-autoevaluacion':true,
                                            'estado-pendiente': autoEvaluacion[a].dimensiones[d].finalizado === 0,
                                            'estado-enCurso': autoEvaluacion[a].dimensiones[d].finalizado === 1, 
                                            'estado-finalizado': autoEvaluacion[a].dimensiones[d].finalizado === 2}"></span>
                                        <div>
                                            <h4>{{dimension.dimension}}</h4>
                                            <label>{{dimension.elementos.length}} elementos de gestión</label>
                                        </div>
                                    </mat-panel-title>
                                    <mat-panel-description>
                                        <img style="width: 40px;" *ngIf="!acordeonDimension.expanded" src="../../../.././../../assets/icons/JUNJI__green-plus.svg">
                                        <img style="width: 40px;" *ngIf="acordeonDimension.expanded" src="../../../.././../../assets/icons/JUNJI__green-less.svg">
                                    </mat-panel-description>
                                </mat-expansion-panel-header>
                                <div *ngFor="let elemento of dimension.elementos; let e = index">
                                    <div class="row" style="border-top: solid 10px white;">
                                        <div class="col-sm-8 pregunta" style="border-right: solid 10px white;">
                                            {{dimension.nombreCorto}} {{elemento.nombreCorto}} {{elemento.elementoGestion}}
                                        </div>
                                        <div class="col-sm-2 pregunta" style="border-right: solid 10px white;text-align: center;">
                                            <p style="margin-bottom: 0;">PJE. AUTOEVALUACIÓN</p>
                                            {{elemento.notaJardin}}
                                        </div>
                                        <div class="col-sm-2 pregunta" style="text-align: center;">
                                            <p style="margin-bottom: 0;">PJE. VALIDACIÓN</p>
                                            {{elemento.notaValidacion}}
                                        </div>
                                    </div>

                                    <div class="row">
                                        <div class="col-sm-12">
                                            
                                            <p style="    text-align: left;
                                            font: normal normal 600 16px/26px Hind Siliguri;
                                            letter-spacing: 0px;
                                            color: #30374B;
                                            text-transform: uppercase;
                                            margin-bottom: 0px;display: inline-block;margin-right: 30px;">¿DESEA APELAR?</p>
                                            <mat-slide-toggle
                                                [(ngModel)]="elemento.apela"
                                                [disabled]="jardinPeriodoInforme.envioApeliacion"
                                                (change)="updateElemento(elemento)"
                                                class="example-margin"
                                                >
                                                Sí
                                            </mat-slide-toggle>
                                        </div>
                                    </div>
                                    <div class="row" style="background: #EAFBF9 0% 0% no-repeat padding-box;
                                    border: 1px solid #0DBFAD;
                                    border-radius: 10px;padding: 10px;">
                                        <div class="col-sm-12">
                                            <p style="    text-align: left;
                                            font: normal normal 600 14px/30px Montserrat;
                                            letter-spacing: 0px;
                                            color: #00B09E;
                                            margin-bottom: 0;">Determine qué prácticas de este elemento de gestión no fueron acreditadas y que usted considera que sí corresponde acreditar. Se solicita que sea precisa. Indique cuál o cuáles medios de verificación presentados acreditan cada una de estas prácticas.</p>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-12">
                                            <p style="    text-align: left;
                                            font: normal normal 600 16px/26px Hind Siliguri;
                                            letter-spacing: 0px;
                                            color: #30374B;
                                            text-transform: uppercase;
                                            margin-bottom: 0px;">JUSTIFICACIÓN DE APELACIÓN:</p>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-12">
                                            <textarea (change)="updateElemento(elemento)" name="observacionApelacion" #observacionApelacion="ngModel" [(ngModel)]="elemento.observacionApelacion" cols="30" rows="4" [attr.disabled]="!elemento.apela || jardinPeriodoInforme.envioApeliacion ? true : null"></textarea>
                                        </div>
                                    </div>
                                    
                                    <div style="padding: 2% 3%;">
                                        
                                        <p style="    text-align: left;
                                            font: normal normal 600 16px/26px Hind Siliguri;
                                            letter-spacing: 0px;
                                            color: #30374B;
                                            text-transform: uppercase;
                                            margin-bottom: 0px;">Medios de Verificación: </p>

                                        <table class="medio-verificacion">
                                            <tr>
                                                <th>NÚMERO</th>
                                                <th>NOMBRE DE MEDIO</th>
                                                <th>COMENTARIO</th>
                                                <th>ACCIONES</th>
                                            </tr>
                                            <tr *ngFor="let vinculado of elemento.vinculados; let v = index">
                                                <td>{{v + 1}}</td>
                                                <td>{{vinculado.nombre}}</td>
                                                <td>{{vinculado.comentario}}</td>
                                                <td>
                                                    <img (click)="descargarMedio(vinculado.idMedioVerificacion)" style="width: 35px;margin: 5px;cursor: pointer;" src="../../../.././../../../assets/icons/JUNJI_download.svg">
                                                    
                                                </td>
                                            </tr>
                                        </table>
                                    
                                    </div>
                                    
                                </div>
                            </mat-expansion-panel>
                        </mat-accordion>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </div>
    </div>




<ngx-spinner></ngx-spinner>




